'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var background = _ref.background,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      foreground = _ref.foreground,
      margin = _ref.margin,
      radius = _ref.radius,
      spacing = _ref.spacing,
      styles = _ref.styles;
  var colors = _ref2.colors,
      radiuses = _ref2.radiuses,
      rhythm = _ref2.rhythm,
      calculateSpacing = _ref2.calculateSpacing;
  return {
    root: (0, _merge2.default)(_extends({}, calculateSpacing(spacing), calculateSpacing(margin, 'margin'), {
      backgroundColor: background && colors[background],
      color: foreground && colors[foreground],
      border: borderWidth && borderWidth + 'px solid ' + colors[borderColor],
      borderRadius: radius && rhythm(radiuses[radius])
    }), styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/section/styles.js
// module id = 870
// module chunks = 0